import { useContext } from 'react';
import { AudioContext } from './context';

export const useAudioContext = () => useContext(AudioContext);
